/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersByUserResponse } from '../../models/members-by-user-response';

export interface GetListOfMembersApiV2MembersUserMeGet$Params {
}

export function getListOfMembersApiV2MembersUserMeGet(http: HttpClient, rootUrl: string, params?: GetListOfMembersApiV2MembersUserMeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersByUserResponse>> {
  const rb = new RequestBuilder(rootUrl, getListOfMembersApiV2MembersUserMeGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersByUserResponse>;
    })
  );
}

getListOfMembersApiV2MembersUserMeGet.PATH = '/api/v2/members/user/me';
